import { render, staticRenderFns } from "./SurveyPanel.vue?vue&type=template&id=40989d67"
import script from "./SurveyPanel.vue?vue&type=script&lang=js"
export * from "./SurveyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports